/**
 * Define action constants to be reused here 'constants.ts'
 */
/** *** */

const kUserLoggedIn = "kUserLoggedIn";
const kUserLoggedOut = "kUserLoggedOut";

export { kUserLoggedIn, kUserLoggedOut };
